import React from 'react';
import PropTypes from 'prop-types';
import { trackEcommerce } from 'dibs-tracking';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { getCategories } from '../../utils/categoryHelpers';

import { SbSharedLink } from '../SbSharedLink/SbSharedLink';

import styles from './SbSharedPriceTile.scss';

const getPageLevel = ({ appliedFilters }) => {
    const categories = getCategories(appliedFilters);
    return categories.length;
};

export class SbSharedPriceTileComponent extends React.Component {
    constructor(props) {
        super(props);
        this.getPromotionTrackingObject = this.getPromotionTrackingObject.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        trackEcommerce({
            type: 'promotionImpression',
            promotions: [this.getPromotionTrackingObject()],
        });
    }

    getPromotionTrackingObject() {
        const { position, promoLabel, itemSearch } = this.props;

        return {
            creative: get(itemSearch, 'meta.header'),
            id: `L${getPageLevel(itemSearch)}|${promoLabel}`,
            name: `L${getPageLevel(itemSearch)}-Trade Tiles`,
            position,
        };
    }

    handleClick() {
        trackEcommerce({
            type: 'promoClick',
            promotions: [this.getPromotionTrackingObject()],
        });

        if (typeof this.props.onClick === 'function') {
            this.props.onClick();
        }
    }

    render() {
        const {
            dataTn = 'price-tile',
            displayName,
            hoverMessage,
            IconComponent,
            image,
            isPriceBucket,
            isSbUrl,
            url,
        } = this.props;

        let innerContent;
        if (isPriceBucket) {
            innerContent = (
                <div className={styles.imageContainer}>
                    <img className={styles.image} src={image} />
                    <div className={styles.priceBucketTileOverlay} />
                    <div className={styles.priceBucketTileHoverMessage}>{hoverMessage}</div>
                </div>
            );
        } else {
            const bgImageStyle = { backgroundImage: `url(${image})` };
            innerContent = (
                <div className={styles.imageContainer}>
                    <div className={styles.bgImage} style={bgImageStyle} />
                    <div className={styles.tileOverlay} />
                    <div className={styles.tileHoverMessage}>
                        <IconComponent className={styles.icon} />
                        {hoverMessage}
                    </div>
                </div>
            );
        }

        const content = (
            <React.Fragment>
                {innerContent}
                <div data-tn="price-tile-name" className={styles.displayName}>
                    {displayName}
                </div>
            </React.Fragment>
        );

        const linkProps = {
            className: styles.tile,
            href: url,
            onClick: this.handleClick,
        };

        if (isSbUrl) {
            return (
                <SbSharedLink {...linkProps} dataTn={dataTn}>
                    {content}
                </SbSharedLink>
            );
        }

        return (
            <a {...linkProps} data-tn={dataTn}>
                {content}
            </a>
        );
    }
}

SbSharedPriceTileComponent.propTypes = {
    dataTn: PropTypes.string,
    displayName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hoverMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    IconComponent: PropTypes.func,
    image: PropTypes.string,
    isPriceBucket: PropTypes.bool,
    onClick: PropTypes.func,
    position: PropTypes.number.isRequired,
    promoLabel: PropTypes.string.isRequired,
    itemSearch: PropTypes.object,
    isSbUrl: PropTypes.bool,
    url: PropTypes.string,
};

SbSharedPriceTileComponent.defaultProps = {
    isSbUrl: true,
};

export const SbSharedPriceTile = createFragmentContainer(SbSharedPriceTileComponent, {
    itemSearch: graphql`
        fragment SbSharedPriceTile_itemSearch on ItemSearchQueryConnection {
            meta {
                header
            }
            appliedFilters {
                name
                values {
                    urlLabel
                }
            }
        }
    `,
});
